import { useState } from "react";
import Modal from "react-modal";
import InputMask from "react-input-mask";
import { MainButton } from "../MainButton";
import { useNavigate, useParams } from "react-router-dom";
import { useSeller } from "../../hooks/useSeller";
import { cpfCnpjNoMask, telephoneNoMask } from "../../functions/mask";
import { useOrder } from "../../hooks/useOrder";
import Swal from "sweetalert2";
import "./index.css";
import api from "../../services/api";
import { usePluginspace } from "../../hooks/usePluginspace";
import { OrderToSendType } from "../../contexts/OrderContext";
import { v4 as uuidv4 } from "uuid";
import { Input } from "../Input/Input";

type ModalProps = {
    isOpen: boolean;
    setIsOpen: (value: boolean) => void;
    backgroundButton?: string;
    fontButton?: string;
    setLoading: (value: boolean) => void;
    typeFreight?: string;
    valueFreight?: number;
    changeValue : (value: number) => void
    newValueFreight : (value: number) => void
};


export function ModalEditFreight({
    isOpen,
    setIsOpen,
    backgroundButton,
    fontButton,
    setLoading,
    typeFreight,
    valueFreight,
    changeValue,
    newValueFreight,
}: ModalProps) {
    const [newFreigth, setNewFreight] = useState(valueFreight);
    const changeFreight = async () => {
        changeValue(newFreigth!);
        newValueFreight(newFreigth!);
        setIsOpen(false)

    }

    const changeType = (type:string)=>{
        if(type === 'delivery'){
            return 'Entrega'
        }else{
            return 'Retirada'
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={() => setIsOpen(false)}
            className="modal-table-cart"
            contentLabel="Definir mesa"
            overlayClassName="overlay-modal"
            ariaHideApp={false}
        >
            <div className="modal-table-cart-content">
                <div className="modal-table-cart-body">
                    <div className="title">
                        <h2>Novo Valor {changeType(typeFreight!)}</h2>
                        <svg
                            onClick={() => setIsOpen(false)}
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M0.978551 2.97126L6.957 8.94971L0.978551 14.9282L2.97137 16.921L8.94981 10.9425L14.9283 16.921L16.9211 14.9282L10.9426 8.94971L16.9211 2.97126L14.9283 0.978446L8.94981 6.95689L2.97137 0.978446L0.978551 2.97126Z"
                                fill="#636363"
                            />
                        </svg>
                    </div>
                    <div className="modal-table-form">
                        <div>
                            <Input
                                inputAttr={{
                                    type: 'money',
                                }}
                                locale="pt-BR"
                                currency='BRL'
                                label={'Freight'}
                                value={newFreigth}
                                change={(value: string) => {
                                    setNewFreight(parseFloat(value))
                                }}

                            />
                        </div>
                        <div>
                            <MainButton
                                color={fontButton ? fontButton : "#636363"}
                                backgroundColor={
                                    backgroundButton
                                        ? backgroundButton
                                        : "#EAEAEA"
                                }
                                text="Trocar Valor"
                                onClick={() => changeFreight()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}